export const isDundee = () => {
  const origin = document.getElementById("reptile-search-result")?.getAttribute("data-origin");
  return origin === "dundee";
};
